import { jsx as r, jsxs as a, Fragment as M } from "react/jsx-runtime";
import { Listbox as O, ListboxButton as T, ListboxOptions as V } from "@headlessui/react";
import { useRef as l } from "react";
import { ArrowDown as W } from "../../icons/arrow-down-icon.mjs";
import { FormInput as q } from "./form-input.mjs";
import { twMerge as e } from "tailwind-merge";
import { useTranslation as E } from "../../i18n.mjs";
import { usePhoneInput as G } from "./react-international-phone/hooks/use-phone-input.mjs";
import { FieldLabel as H } from "../form/field-label.mjs";
import { CountrySelector as J } from "./react-international-phone/components/country-selector/country-selector.mjs";
import { CountrySelectorDropdown as K } from "./react-international-phone/components/country-selector/country-selector-dropdown.mjs";
const le = ({
  label: p,
  labelClassName: b,
  required: f,
  value: h,
  onChange: x,
  error: g,
  wrapperClassName: w,
  inputClassName: N,
  listClassName: y,
  searchInputClassName: v,
  clearSearchInputClassName: C,
  listItemClassName: I,
  listItemCountryNameClassName: L,
  countrySelectorDropdownClassName: S,
  countrySelectorClassName: _,
  buttonClassName: F,
  listboxButtonClassName: R,
  listboxOptionsClassName: k,
  initialCountry: o,
  ...t
}) => {
  const { t: d } = E(), P = l(null), j = l(null), n = l(null), { country: u, setCountry: z, phone: D, handlePhoneValueChange: $, onFocus: A, inputRef: c } = G({
    value: h,
    onChange: ({ unformatedPhone: s }) => x(s),
    initialCountry: o == null ? void 0 : o.toLowerCase()
  });
  return /* @__PURE__ */ r("div", { className: w, children: /* @__PURE__ */ r(O, { children: ({ open: s }) => {
    var m;
    return /* @__PURE__ */ a(M, { children: [
      /* @__PURE__ */ a("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ r(
          H,
          {
            label: p,
            required: f,
            labelClassName: e("text-sm font-medium", b)
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            ref: j,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ a(
                T,
                {
                  ref: n,
                  as: "div",
                  role: "button",
                  disabled: t.disabled,
                  className: e(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    R,
                    t.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ r(
                      J,
                      {
                        className: e("flex", _),
                        buttonStyle: { border: "none" },
                        buttonClassName: e(
                          t.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          F
                        ),
                        hideDropdown: !0,
                        disabled: t.disabled,
                        selectedCountry: u,
                        defaultCountry: o == null ? void 0 : o.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ r(
                      W,
                      {
                        className: `transition-transform duration-300 ${s && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ r(
                q,
                {
                  ref: c,
                  type: "tel",
                  placeholder: d("public_pages_purchase.input.phone_number"),
                  inputClassName: e(
                    "pl-16",
                    s && "border-brand-primary",
                    N
                  ),
                  value: D,
                  onChange: $,
                  onFocus: A,
                  error: g,
                  ...t
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ r(
        V,
        {
          className: e("focus-visible:outline-hidden", k),
          children: /* @__PURE__ */ r(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: P,
              style: {
                width: `${(m = c.current) == null ? void 0 : m.clientWidth}px`
              },
              children: /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(
                K,
                {
                  className: e(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    S
                  ),
                  listClassName: e(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    y
                  ),
                  searchInputClassName: e(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    v
                  ),
                  clearSearchInputClassName: e(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    C
                  ),
                  listItemClassName: e(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    I
                  ),
                  listItemCountryNameClassName: e(
                    "truncate",
                    L
                  ),
                  searchInputPlaceholder: d("public_pages_purchase.input.phone_search"),
                  show: s,
                  selectedCountry: u,
                  onSelect: (B) => {
                    var i;
                    z(B.iso2), (i = n.current) == null || i.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
};
export {
  le as FormInputPhone
};
